export const companyName = "AJ Marketing Enterprise";
export const companyRegistrationNumber = "202403297638 (LA0073431-H)";
export const officeAddress = "";
export const contactNumber = "";
export const enquiryEmail = "";